import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-card',
  templateUrl: './page-card.component.html',
  styleUrls: ['./page-card.component.scss']
})
export class PageCardComponent {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";


  constructor() { }

}
